<template>
  <va-create-layout>
    <croppings-form :title="title" :item="item"></croppings-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ['title', 'item'],
}
</script>
